export const ERROR_DISPLAY_TYPE = {
  SNACKBAR: 'SNACKBAR',
  DIALOG: 'DIALOG',
};
